import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import styles from "./comboBox.module.scss";
import { getAwsAssets } from "@src/utils";

export default function SelectMultipleComboBox({
  index,
  limit,
  items,
  title,
  handleCheckboxChange,
  setErrorStates,
  setPhysicalDeliveryEnabledStates,
}) {
  const [selected, setSelected] = useState({});

  const checkBoxTick = getAwsAssets("checkbox.png", "layout");

  const handleCheckboxChangeLocal = (checked, item) => {
    const courseId = item.courseId;

    if (checked) {
      const isLimitAvailable = checkLimit();
      if (isLimitAvailable) {
        setSelected((prev) => ({ ...prev, [courseId]: true }));
      } else {
        toast.error(`Cannot add more than ${limit} courses`, {
          duration: 2000,
        });
      }
    } else {
      setSelected((prev) => ({ ...prev, [courseId]: false }));
    }
  };

  const checkLimit = () => {
    let selectedCount = 0;
    Object.values(selected).forEach((val) => {
      if (val) {
        selectedCount = selectedCount + 1;
      }
    });

    if (selectedCount < limit) return true;

    return false;
  };

  useEffect(() => {
    let selectedObj = {};
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      selectedObj[item.courseId] = false;
    }
    setSelected(selectedObj);
  }, []);

  useEffect(() => {
    // CHECK FOR ERROR
    let selectedCount = 0;
    let keys = Object.keys(selected);
    for (let i = 0; i < keys.length; i++) {
      if (selected[Number(keys[i])] === true) {
        selectedCount = selectedCount + 1;
      }
    }

    if (selectedCount === limit) {
      setErrorStates((prev) => ({ ...prev, [index]: false }));
    } else {
      setErrorStates((prev) => ({ ...prev, [index]: true }));
    }

    handleCheckboxChange(selected);
  }, [selected]);

  useEffect(() => {
    // PHYSICAL DELIVERY
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (selected.hasOwnProperty(item?.courseId)) {
        if (
          selected[item?.courseId] === true &&
          item?.isPhysicalDeliveryEnabled
        ) {
          setPhysicalDeliveryEnabledStates((prev) => ({
            ...prev,
            [item?.courseId]: item?.isPhysicalDeliveryEnabled,
          }));
        } else {
          setPhysicalDeliveryEnabledStates((prev) => ({
            ...prev,
            [item?.courseId]: false,
          }));
        }
      }
    }
  }, [selected]);

  console.log(index, limit, items, title, "lidnwailndliwandilnwaildnawl");

  return (
    <div className={styles.comboBox}>
      <div className={styles.comboBoxTitle}>{title}</div>
      <div className={styles.comboBoxSubtitle}>Select any {limit}</div>
      <div className={styles.comboBoxCard}>
        {items &&
          items.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  if (!item?.isPurchased) {
                    if (selected[item?.courseId] === true) {
                      handleCheckboxChangeLocal(false, item);
                    } else {
                      handleCheckboxChangeLocal(true, item);
                    }
                  }
                }}
                className={styles.comboBoxCardSingleItem}
              >
                <div className={styles.comboBoxCardSingleItemLeft}>
                  {item?.facultyIcon ? (
                    <img
                      height={36}
                      width={36}
                      src={item?.facultyIcon}
                      alt="avatar"
                      style={{ borderRadius: "999px" }}
                    />
                  ) : (
                    <div className={styles.comboBoxAvatar}>
                      {item?.facultyName?.[0]?.toUpperCase()}
                    </div>
                  )}
                  <p>
                    {item?.facultyName}
                    {item?.isPurchased ? (
                      <div
                        style={{
                          fontSize: "12px",
                          padding: "6px",
                          color: "#7D8592",
                          background: "#FFF7E5",
                          marginTop: "8px",
                          fontWeight: 500,
                        }}
                      >
                        ALREADY PURCHASED
                      </div>
                    ) : null}
                  </p>
                </div>
                <div>
                  {selected[item?.courseId] === true ? (
                    <img
                      height={24}
                      width={24}
                      onClick={() => handleCheckboxChangeLocal(false, item)}
                      src={getAwsAssets("blueTick.svg", "layout")}
                    />
                  ) : (
                    <input
                      disabled={item?.isPurchased}
                      className={styles.comboBoxCheckbox}
                      checked={selected[item?.courseId] === true}
                      style={{ background: item?.isPurchased ? "#eee" : "" }}
                      onChange={(e) => handleCheckboxChangeLocal(true, item)}
                      type="checkbox"
                    />
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
